import { Controller } from "@hotwired/stimulus"

// Shell controller for the Illustrated Carousel wizard. Mirrors
// vocabulary_set_wizard_controller — exposes configId + step to nested
// controllers; cross-step state lives in the backend + URL, not here. Slide
// add/remove are server round-trips (member-action links), so there's no
// client-side list state to manage for the MVP.
export default class extends Controller {
  static values = {
    configId: Number,
    step: String,
  }

  connect() {
    // Intentionally empty. Hook here if the wizard grows client-side
    // navigation or unsaved-change warnings.
  }
}
